// extracted by mini-css-extract-plugin
module.exports = {"job_employee_section":"styles_job_employee_section__3cDvK","btn_accent_width":"styles_btn_accent_width__1DdiO"};